<div class="breadcrumbs">
    <ol class="breadcrumbs__list" *ngIf="breadcrumbs$ | async as breadcrumbs">
        <li class="breadcrumbs__list-item">
            <a class="breadcrumbs__list-link--home-icon" aria-label="Goto homepage" routerLink="/"></a>
        </li>
        <li class="breadcrumbs__list-item" *ngFor="let breadcrumb of breadcrumbs.parents">
            <a class="breadcrumbs__list-link" (click)="navigateToPage((breadcrumb.meta?.redirect) || ('/' + breadcrumb.url))" href="javascript:void(0)">{{breadcrumb.name | translate}}</a>
        </li>
        <li class="breadcrumbs__list-item breadcrumbs__list-item--current">{{breadcrumbs.name}}</li>
    </ol>
</div>
